import axios from 'axios';
import {all, call, fork, put, takeEvery, select} from "redux-saga/effects";

import {
    SET_PACKAGE_MENU,
    GET_PACKAGE_MENU,
    REQ_ALL_PACKAGE,
    REQ_ADD_PACKAGE,
    REQ_EDIT_PACKAGE,
    REQ_DELETE_PACKAGE,
    GET_ALL_PACKAGE,
    GET_ADD_PACKAGE,
    GET_EDIT_PACKAGE,
    GET_DELETE_PACKAGE,
    SUCCESS_MESSAGE_PACKAGE,
    ERROR_MESSAGE_PACKAGE,
    BASE_URL_APIv5,
} from "constants/ActionTypes";

const callAllPackage =  async () => {
    const token = localStorage.getItem('apiKey')

    const config = {
        headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
        }
    }
    return await axios.get(`${BASE_URL_APIv5}/package-menu/list`, config)
                    .then(res => res)
                    .catch(error => error.response)
}

const callAddPackage =  async (name) => {
    const data = {package_name: name}
    const token = localStorage.getItem('apiKey')

    const config = {
        headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
        }
    }

    const arr = JSON.stringify(data)
    return await axios.post(`${BASE_URL_APIv5}/package-menu/new`, arr, config)
                    .then(res => res)
                    .catch(error => error.response)
}

const callEditPackage = async (id, name) => {

    const data = {package_name: name}
    const token = localStorage.getItem('apiKey')

    const config = {
        headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
        }
    }

    const arr = JSON.stringify(data)
    return await axios.put(`${BASE_URL_APIv5}/package-menu/edit/${id}`, arr, config)
                    .then(res => res)
                    .catch(error => error.response)
}

const callSetPakcage = async (data) => {

    const token = localStorage.getItem('apiKey')

    const config = {
        headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
        }
    }

    const arr = JSON.stringify(data)
    return await axios.put(`${BASE_URL_APIv5}/package-module/edit-all`, arr, config)
                    .then(res => res)
                    .catch(error => error.response)
}

const callDeletePackage = async (id) => {
    const token = localStorage.getItem('apiKey')

    const config = {
        headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
        }
    }
    return await axios.delete(`${BASE_URL_APIv5}/package-menu/delete/${id}`, config)
                    .then(res => res)
                    .catch(error => error.response)
}


export function* setMenuPackage (data){
    try {
        // console.log('set package')
        // console.log(data.action)
        const result = yield call(callSetPakcage, data.action)
        // console.log(result)
        if(result.status === 200) {
            // console.log('set package success')
            const success = 'Data Successfuly Updated'
            yield put({type: SUCCESS_MESSAGE_PACKAGE, payload: success})
        }
    } catch (error) {
        const error = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_PACKAGE, payload: error})
    }
}

export function* setAllPackage (){
    const arr = []
    try {
        const result = yield call(callAllPackage)
        if(result.data.status === true){
            const data = result.data.data
            // console.log(data)
            // data.map(res => {
            //     arr.push({...res._source})
            // })
            // // console.log(arr)
            yield put({type: GET_ALL_PACKAGE, payload: data})
        } else {
            const error = 'Opps! looks like something wrong'
            yield put({type: ERROR_MESSAGE_PACKAGE, payload: result.data.message})
        }
        
    } catch (error) {
        const error = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_PACKAGE, payload: error})
    }
}

export function* setAddPackage (data){
    try {
        const result = yield call(callAddPackage, data.action)
        // console.log(result)
        if (result.status === 200){
            yield put({type: GET_ADD_PACKAGE, payload: result.data.data})
            const success = 'Data Successfuly Created'
            yield put({type: SUCCESS_MESSAGE_PACKAGE, payload: success})
        }
    } catch (error) {
        const error = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_PACKAGE, payload: error})
    }
}

export function* setEditPackage (data){
    try {
        const {id, name} = data.action
        const result = yield call(callEditPackage, id, name)
        // console.log(result)
        if (result.status === 200){
            const success = 'Data Successfuly Updated'
            yield put({type: SUCCESS_MESSAGE_PACKAGE, payload: success})
        }
    } catch (error) {
        const error = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_PACKAGE, payload: error})
    }
}

export function* setDeletePackage (data){
    try {
        // console.log(`id from delete saga is ${data.action}`)
        const result = yield call(callDeletePackage, data.action)
        // console.log(result)
        if (result.status === 200){
            const success = 'Data Successfuly Deleted'
            yield put({type: SUCCESS_MESSAGE_PACKAGE, payload: success})
        }
    } catch (error) {
        const error = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_PACKAGE, payload: error})
    }
}


export function* setPackageMenu(){
    yield takeEvery(SET_PACKAGE_MENU, setMenuPackage)
}

export function* reqAllPackage(){
    yield takeEvery(REQ_ALL_PACKAGE, setAllPackage)
}

export function* reqAddPackage(){
    yield takeEvery(REQ_ADD_PACKAGE, setAddPackage)
}

export function* reqEditPackage(){
    yield takeEvery(REQ_EDIT_PACKAGE, setEditPackage)
}``

export function* reqDeletePackage(){
    yield takeEvery(REQ_DELETE_PACKAGE, setDeletePackage)
}


export default function* rootSaga() {
    yield all([
        fork(setPackageMenu),
        fork(reqAllPackage),
        fork(reqAddPackage),
        fork(reqEditPackage),
        fork(reqDeletePackage),
    ]);
}


// WEBPACK FOOTER //
// ./sagas/Packages.js